export default __webpack_public_path__ + "static/media/mouse-button.3c1491b9.svg";